module.exports = __webpack_public_path__ + "static/media/picksv.00f339e0.svg";